// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._syaz131l{color:var(--ds-text-subtlest,#626f86)}", ""]);
// Exports
module.exports = exports;
